/* istanbul ignore file */
import { EnumDropdown } from 'framework/form';
import React from 'react';
import { CandidateApplicationStatusOptions } from 'domain/recruiting/candidate/applications/shared/candidateApplicationService';

const CandidateApplicationStatusDropdown = (props: any) => {
  return (
    <EnumDropdown placeholder="Choose Application Status" options={CandidateApplicationStatusOptions} {...props} />
  );
};

export default CandidateApplicationStatusDropdown;
